import React, { useState } from 'react'
import { BsChevronLeft } from 'react-icons/bs'
import SideNav from '../../Components/SideNav'
import styles from "./Styles/Documents.module.css"
import common from "./Styles/Common.module.css"
import { AiFillFolder, AiOutlineEye } from 'react-icons/ai'
import Search from "../../Components/Search"
import Button from "../../Components/Button"
import { FiDownload } from 'react-icons/fi'
import {RiDeleteBin6Line} from "react-icons/ri"
import { useNavigate } from 'react-router-dom'

export default function Documents() {

  const [selectedFolder, setSelectedFolder] = useState('Layouts')
  const navigate = useNavigate()

  return (
    <div className={common.container}>
        <div className={common.backIcon}>
            <div onClick={()=>navigate('/dashboard/leads')}>
                <BsChevronLeft size={26} color="#0E1123" />
            </div>
            <p>Back</p>
        </div>

        <main>
            <SideNav />
            <div className={`${common.main} ${styles.main}`}>
                
                <div className={styles.folders}>
                    <h2>Folders</h2>
                    <div className={selectedFolder == 'Layouts' && styles.activeFolder} onClick={()=>setSelectedFolder('Layouts')}>
                        <AiFillFolder color="#109CF1" size={20} />
                        <p>Layouts</p>
                        <span>23 Files</span>
                    </div>
                    <div className={selectedFolder == 'Pictures' && styles.activeFolder} onClick={()=>setSelectedFolder('Pictures')}>
                        <AiFillFolder color="#109CF1" size={20} />
                        <p>Pictures</p>
                        <span>02 Files</span>
                    </div>
                    <div className={selectedFolder == 'Documents' && styles.activeFolder} onClick={()=>setSelectedFolder('Documents')}>
                        <AiFillFolder color="#109CF1" size={20} />
                        <p>Documents</p>
                        <span>12 Files</span>
                    </div>
                </div>

                <div className={styles.files}>
                    <div style={{display:'flex',alignItems:'center',gap:20}}>
                        <Search placeholder="Search file..." />
                        <Button width={164} bgColor="#60D1D0" title="Upload File" />
                    </div>

                    {selectedFolder == 'Layouts' && <div className={styles.allFiles}>
                        {Array(6).fill('').map(item => {
                            return <div className={styles.file}>
                            <div className={styles.fileIcon}>

                            </div>
                            <div style={{flex:1}}>
                                <p style={{marginBottom:8}}>Office_layout.pdf</p>
                                <p style={{color:'#707683'}}>5 mb</p>
                            </div>
                            <div className={styles.icons}>
                                <div>
                                    <AiOutlineEye size={18} color="#6DB4C4" />
                                </div>
                                <div>
                                    <FiDownload size={18} color="#6DB4C4" />
                                </div>
                                <div>
                                    <RiDeleteBin6Line size={18} color="#F7685B" />
                                </div>
                            </div>
                        </div>
                        })}
                    </div>}
                </div>

            </div>
        </main>
    </div>
  )
}
